import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/theMidAutumnFestival/2025/Index.vue')
const LotteryRewards = () => import('../activity/theMidAutumnFestival/2025/LotteryRewards.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/the-mid-autumn-festival/2025',
  name: 'activity_the_mid_autumn_festival_2025',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '中秋月饼铺',
  },
}

export const lotteryRewardsRoute: RouteConfig = {
  path: '/activity/the-mid-autumn-festival/2025/lottery-rewards',
  name: 'activity_the_mid_autumn_festival_2025_lottery_rewards',
  component: LotteryRewards,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '抽奖记录',
  },
}

export default [indexRoute, lotteryRewardsRoute]
